import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from '@material-ui/core/Select';
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';

import { filterChange } from '../../actions/index';

import { _ } from '../../functions/translator';
import { FilterActions } from '../../constants/constants';

class AppartmentDropdown extends React.Component{

    handleAppartmentChange = (event) => {
        let appartmentIds = [];
        let levelSelected = null;
        for (const appartmentId of event.target.value) {
            const isALevel = typeof appartmentId === 'object';
            if (isALevel) {
                levelSelected = appartmentId;
            } else {
                appartmentIds.push(appartmentId);
            }
        }
        if (levelSelected) {
            appartmentIds = this.handleLevelSelected(appartmentIds, levelSelected);
        }
        this.props.filterChange(FilterActions.APPARTMENTS, appartmentIds);
    };

    handleLevelSelected = (appartmentIds, levelSelected) => {
        let levelAppartmentsData = Object.values(this.props.appartmentsData).filter((appartmentData) => appartmentData.attributes.level_id === levelSelected.id);
        let levelAppartmentIds = levelAppartmentsData.map((appartmentData) => appartmentData.id);
        let appartmentsSelected = levelAppartmentIds.map((appartmentId) => { 
            return appartmentIds.indexOf(appartmentId) !== -1;
        });
        const areAllAppartmentsSelected = !appartmentsSelected.includes(false);
        if (areAllAppartmentsSelected) {
            appartmentIds = appartmentIds.filter((appartmentId) => {
                return !levelAppartmentIds.includes(appartmentId);
            });
        } else {
            levelAppartmentIds.forEach((appartmentId) => {
                if (!appartmentIds.includes(appartmentId)) {
                    appartmentIds.push(appartmentId);
                }
            });
        }
        return appartmentIds;
    }

    handleSelected = (appartmentsSelected) => {
        if (appartmentsSelected.length === 0) {
            return _('Todo')
        } else {
            let appartmentNames = []
            for (const appartmentId of appartmentsSelected) {
                let appartmentData = this.props.appartmentsData[appartmentId.toString()]
                appartmentNames.push(appartmentData.attributes.name)
            }
            return appartmentNames.join(', ')
        }
    }

    levelHasAppartments = (levelId) => {
        for (const appartmentData of Object.values(this.props.appartmentsData)) {
            if (appartmentData.attributes.level_id === levelId) {
                return true;
            }
        }
        return false;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.levelIds !== this.props.levelIds) {
            const appartmentIds = []
            for (const appartmentId of this.props.appartmentIds) {
                const appartmentData = this.props.appartmentsData[appartmentId];
                const levelId = appartmentData.attributes.level_id;
                if (this.props.levelIds.includes(levelId)) {
                    appartmentIds.push(appartmentId);
                }
            }
            this.props.filterChange(FilterActions.APPARTMENTS, appartmentIds);
        }
    }

    render() {
        const appartmentsList = []
        for (const levelData of Object.values(this.props.levelsData)) {
            if (this.props.levelIds.length > 0 && !this.props.levelIds.includes(levelData.id)) continue;
            if (!this.levelHasAppartments(levelData.id)) continue;
            appartmentsList.push(
                <ListSubheader color="inherit" value={levelData} classes={{root: 'cursor-pointer'}}>
                    {levelData.attributes.name}
                </ListSubheader>
            );
            for (const [key, appartmentData] of Object.entries(this.props.appartmentsData)) {
                if ((levelData.id === appartmentData.attributes.level_id)) {
                    appartmentsList.push(
                        <MenuItem value={appartmentData.id} key={key}>
                            <Checkbox color="primary" checked={this.props.appartmentIds.includes(appartmentData.id)}/>
                            {appartmentData.attributes.name}
                        </MenuItem>
                    )
                }
            }
        }

        return(
            <div>
                <Select
                value={this.props.appartmentIds}
                multiple={true}
                displayEmpty={true}
                renderValue={this.handleSelected}
                onChange={this.handleAppartmentChange}
                MenuProps={{
                    PaperProps: {
                        style: {
                          maxHeight: 300,
                          top: '0px',
                          position: 'fixed',
                        },
                    },
                    getContentAnchorEl: null,
                }}>
                {appartmentsList}
                </Select>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        appartmentIds   : state.filters.appartmentIds,
        appartmentsData : state.projectData.appartments,
        levelsData      : state.projectData.levels,
        levelIds        : state.filters.levelIds,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange : filterChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(AppartmentDropdown);